module.exports = __webpack_public_path__ + "static/media/YM69_1.5780a4c9.jpg";